import trx from '../assets/images/trx.png';
import revIo from '../assets/images/revio.png';
import edining from '../assets/images/ediningexpress.png';
import memberworks from '../assets/images/memberworks.png';
import tracerflex from '../assets/images/tracerflex.jpg';
import promotix from '../assets/images/promotix.png';
import ensora from '../assets/images/ensora.png';
import intelecom from '../assets/images/intelecom.png';

const parseIds = (raw) => (raw || '').split(',').map((s) => s.trim()).filter(Boolean);

const REVIO_IDS            = parseIds(process.env.REACT_APP_REVIO);
const EDINING_IDS          = parseIds(process.env.REACT_APP_EDINING);
const MW_13601_IDS         = parseIds(process.env.REACT_APP_MW_13601);
const MW_13602_IDS         = parseIds(process.env.REACT_APP_MW_13602);
const MW_GENERAL_IDS       = parseIds(process.env.REACT_APP_MW_GENERAL);
const EXCELR8_IDS          = parseIds(process.env.REACT_APP_EXCELR8);
const TRACERFLEX_IDS       = parseIds(process.env.REACT_APP_TRACERFLEX);
const PROMOTIX_IDS         = parseIds(process.env.REACT_APP_PROMOTIX);
const ENSORA_FLAT_IDS      = parseIds(process.env.REACT_APP_ENSORA_FLAT);
const ENSORA_SURCHARGE_IDS = parseIds(process.env.REACT_APP_ENSORA_SURCHARGE);
const INTELECOM_IDS        = parseIds(process.env.REACT_APP_INTELECOM);

// Derived unions — single source of truth lives in the granular vars above.
const MW_REVIO_IDS = [...MW_13601_IDS, ...MW_13602_IDS];
const ENSORA_IDS   = [...ENSORA_FLAT_IDS, ...ENSORA_SURCHARGE_IDS];

if (process.env.NODE_ENV !== 'production') {
  const mwOverlap = MW_13601_IDS.filter((id) => MW_13602_IDS.includes(id));
  if (mwOverlap.length) console.warn('[agentConfig] ID in both MW_13601 and MW_13602:', mwOverlap);
  const ensoraOverlap = ENSORA_FLAT_IDS.filter((id) => ENSORA_SURCHARGE_IDS.includes(id));
  if (ensoraOverlap.length) console.warn('[agentConfig] ID in both ENSORA_FLAT and ENSORA_SURCHARGE:', ensoraOverlap);
}

const idStr = (agentId) => (agentId != null ? agentId.toString() : '');

export function getAgentType(agentId) {
  const id = idStr(agentId);
  if (!id) return 'trx';

  if (MW_REVIO_IDS.includes(id)) return 'mwRevio';
  if (MW_GENERAL_IDS.includes(id)) return 'mwGeneral';
  if (INTELECOM_IDS.includes(id)) return 'intelecom';
  if (REVIO_IDS.includes(id)) return 'revio';
  if (EDINING_IDS.includes(id)) return 'edining';
  return 'trx';
}

export function isRevioStyle(agentId) {
  const type = getAgentType(agentId);
  return type === 'revio' || type === 'mwRevio' || isEnsora(agentId);
}

export function isEdining(agentId) {
  return getAgentType(agentId) === 'edining';
}

export function isMemberworks(agentId) {
  const type = getAgentType(agentId);
  return type === 'mwRevio' || type === 'mwGeneral';
}

export function isMwGeneral(agentId) {
  return getAgentType(agentId) === 'mwGeneral';
}

export function isMW13601(agentId)         { return MW_13601_IDS.includes(idStr(agentId)); }
export function isMW13602(agentId)         { return MW_13602_IDS.includes(idStr(agentId)); }
export function isExcelR8(agentId)         { return EXCELR8_IDS.includes(idStr(agentId)); }
export function isTracerFlex(agentId)      { return TRACERFLEX_IDS.includes(idStr(agentId)); }
export function isPromotix(agentId)        { return PROMOTIX_IDS.includes(idStr(agentId)); }
export function isIntelecom(agentId)       { return INTELECOM_IDS.includes(idStr(agentId)); }
export function isEnsora(agentId)          { return ENSORA_IDS.includes(idStr(agentId)); }
export function isEnsoraFlat(agentId)      { return ENSORA_FLAT_IDS.includes(idStr(agentId)); }
export function isEnsoraSurcharge(agentId) { return ENSORA_SURCHARGE_IDS.includes(idStr(agentId)); }

const ZERO_NACHA = { ppd: '0', web: '0', ccd: '0', tel: '0', arc: '0', boc: '0', pop: '0' };

const REVIO_BUSINESS_DEFAULTS = {
  industry: 'CardNotPresent',
  returnPolicy: 'NoReturn',
  settlementPolicy: 'OrderDate',
  merchandiseFullfillment: 'Merchant',
  merchandiseDeliverySpan: '1',
  businessLocation: 'Office',
};

const TERMS_URL_DEFAULT   = 'https://framerusercontent.com/assets/d6hMuyOu7fZ0HbQttrXvcpzslc.pdf';
const TERMS_LABEL_DEFAULT = 'Chesapeake Bank – Merchant Processing Agreement Terms and Conditions';
const TERMS_URL_ENSORA    = 'https://www.trxservices.com/terms';
const TERMS_LABEL_ENSORA  = 'Terms and Conditions';

const VOLUME_BASE = {
  creditOnly: false,
  forceAllCardTypes: false,
  lockPpd: false,
};

export const AGENT_CONFIGS = {
  trx: {
    logo: trx,
    logoClass: '',
    sidebarSteps: ['clientInfo', 'corporateInfo', 'contactInfo', 'businessInfo', 'volumeInfo', 'bankInfo'],
    sendAlertEmail: true,
    completionPath: 'standard',
    pricing: { variant: 'standard' },
    termsUrl: TERMS_URL_DEFAULT,
    termsLabel: TERMS_LABEL_DEFAULT,
    business: { mccFilter: 'all', defaults: {} },
    volume: { ...VOLUME_BASE, nachaDefaults: { ...ZERO_NACHA } },
  },
  revio: {
    logo: revIo,
    logoClass: '',
    sidebarSteps: ['clientInfo', 'corporateInfo', 'contactInfo', 'businessInfo', 'volumeInfo', 'bankInfo', 'pricingInfo', 'termsAndConditions', 'eSignature'],
    sendAlertEmail: true,
    completionPath: 'extended',
    pricing: { variant: 'standard' },
    termsUrl: TERMS_URL_DEFAULT,
    termsLabel: TERMS_LABEL_DEFAULT,
    business: {
      mccFilter: ['7399', '4812', '4814', '7393'],
      defaults: { ...REVIO_BUSINESS_DEFAULTS },
    },
    volume: {
      ...VOLUME_BASE,
      forceAllCardTypes: true,
      lockPpd: true,
      nachaDefaults: { ...ZERO_NACHA, ppd: '100' },
    },
  },
  // In-Telecom — Rev.io-based agent with its own logo, telecom MCC list,
  // an 'In-Telecom' pricing label, and ACH NACHA 80/10/10. Intentionally NOT
  // lockPpd, so ACH stays editable and the Rev.io sales-rep gate does not apply.
  intelecom: {
    logo: intelecom,
    logoClass: 'intelecomLogo',
    sidebarSteps: ['clientInfo', 'corporateInfo', 'contactInfo', 'businessInfo', 'volumeInfo', 'bankInfo', 'pricingInfo', 'termsAndConditions', 'eSignature'],
    sendAlertEmail: true,
    completionPath: 'extended',
    pricing: { variant: 'intelecom' },
    termsUrl: TERMS_URL_DEFAULT,
    termsLabel: TERMS_LABEL_DEFAULT,
    business: {
      mccFilter: ['4812', '4814', '7393'],
      defaults: { ...REVIO_BUSINESS_DEFAULTS },
    },
    volume: {
      ...VOLUME_BASE,
      forceAllCardTypes: true,
      nachaDefaults: { ...ZERO_NACHA, ppd: '80', web: '10', ccd: '10' },
    },
  },
  edining: {
    logo: edining,
    logoClass: '',
    sidebarSteps: ['clientInfo', 'corporateInfo', 'contactInfo', 'businessInfo', 'volumeInfo', 'bankInfo'],
    sendAlertEmail: true,
    completionPath: 'standard',
    pricing: { variant: 'standard' },
    termsUrl: TERMS_URL_DEFAULT,
    termsLabel: TERMS_LABEL_DEFAULT,
    business: {
      mccFilter: 'all',
      lockFields: true,
      defaults: {
        industry: 'CardNotPresent',
        merchandise: 'Restaurant',
        returnPolicy: 'NoReturn',
        settlementPolicy: 'OrderDate',
        merchandiseFullfillment: 'Merchant',
        merchandiseDeliverySpan: '1',
        businessLocation: 'StoreFront',
      },
    },
    volume: {
      ...VOLUME_BASE,
      creditOnly: true,
      creditBatchDefaults: {
        monthlyVolume: '50000',
        dailyVolume: '1000',
        averageTicket: '250',
        maximumTicket: '1000',
        percentInternet: '100',
      },
      nachaDefaults: { ...ZERO_NACHA },
    },
  },
  mwRevio: {
    logo: memberworks,
    logoClass: '',
    sidebarSteps: ['clientInfo', 'corporateInfo', 'contactInfo', 'businessInfo', 'volumeInfo', 'bankInfo', 'pricingInfo', 'termsAndConditions', 'eSignature'],
    sendAlertEmail: true,
    completionPath: 'extended',
    pricing: { variant: 'mw13602' }, // overridden in getAgentConfig per mwVariant
    termsUrl: TERMS_URL_DEFAULT,
    termsLabel: TERMS_LABEL_DEFAULT,
    business: {
      mccFilter: ['8641', '8661'],
      mccDefault: '8661',
      defaults: { ...REVIO_BUSINESS_DEFAULTS, ownershipType: 'NonProfit' },
    },
    volume: {
      ...VOLUME_BASE,
      forceAllCardTypes: true,
      nachaDefaults: { ...ZERO_NACHA, ppd: '75', web: '20', ccd: '5' },
    },
  },
  mwGeneral: {
    logo: memberworks,
    logoClass: '',
    sidebarSteps: ['clientInfo', 'corporateInfo', 'contactInfo', 'businessInfo', 'volumeInfo', 'bankInfo'],
    sendAlertEmail: true,
    completionPath: 'standard',
    pricing: { variant: 'standardMw' },
    termsUrl: TERMS_URL_DEFAULT,
    termsLabel: TERMS_LABEL_DEFAULT,
    business: {
      mccFilter: ['8641', '8661'],
      mccDefault: '8661',
      defaults: { ...REVIO_BUSINESS_DEFAULTS, ownershipType: 'NonProfit' },
    },
    volume: {
      ...VOLUME_BASE,
      forceAllCardTypes: true,
      nachaDefaults: { ...ZERO_NACHA, ppd: '75', web: '20', ccd: '5' },
    },
  },
  tracerflex: {
    logo: tracerflex,
    logoClass: 'tracerflexLogo',
    sidebarSteps: ['clientInfo', 'corporateInfo', 'contactInfo', 'businessInfo', 'volumeInfo', 'bankInfo'],
    sendAlertEmail: true,
    completionPath: 'autocomplete',
    pricing: { variant: 'standard' },
    termsUrl: TERMS_URL_DEFAULT,
    termsLabel: TERMS_LABEL_DEFAULT,
    business: { mccFilter: 'all', defaults: {} },
    volume: { ...VOLUME_BASE, nachaDefaults: { ...ZERO_NACHA } },
  },
  promotix: {
    logo: promotix,
    logoClass: 'promotixLogo',
    // Pricing shown right after Client (between Client and Corporate) — Promotix-specific order.
    sidebarSteps: ['clientInfo', 'pricingInfo', 'corporateInfo', 'contactInfo', 'businessInfo', 'volumeInfo', 'bankInfo', 'termsAndConditions', 'eSignature'],
    sendAlertEmail: false,
    completionPath: 'extended',
    pricing: { variant: 'promotix' },
    termsUrl: TERMS_URL_ENSORA,
    termsLabel: TERMS_LABEL_ENSORA,
    business: {
      mccFilter: ['7922', '7941', '7991', '5813', '7997', '7999', '8398', '4899', '7399', '8299'],
      defaults: {
        industry: 'Retail',
        businessLocation: 'Office',
        merchandise: 'Ticket Sales',
        returnPolicy: 'NoReturn',
        settlementPolicy: 'OrderDate',
        merchandiseFullfillment: 'Merchant',
        merchandiseDeliverySpan: '1',
      },
    },
    volume: {
      ...VOLUME_BASE,
      // ACH is not offered for ticket sales — credit-only, so no ACH batch and no NACHA split.
      creditOnly: true,
      forceAllCardTypes: true,
      creditEntryDefaults: { percentSwiped: '10', percentInternet: '90', percentKeyed: '0', percentMailOrder: '0' },
      nachaDefaults: { ...ZERO_NACHA },
    },
  },
  excelR8: {
    logo: trx,
    logoClass: '',
    sidebarSteps: ['clientInfo', 'corporateInfo', 'contactInfo', 'businessInfo', 'volumeInfo', 'bankInfo'],
    sendAlertEmail: true,
    completionPath: 'autocomplete',
    pricing: { variant: 'standard' },
    termsUrl: TERMS_URL_DEFAULT,
    termsLabel: TERMS_LABEL_DEFAULT,
    business: { mccFilter: 'all', defaults: {} },
    volume: { ...VOLUME_BASE, nachaDefaults: { ...ZERO_NACHA } },
  },
  ensora: {
    logo: ensora,
    logoClass: 'ensoraLogo',
    sidebarSteps: ['clientInfo', 'corporateInfo', 'contactInfo', 'businessInfo', 'volumeInfo', 'bankInfo', 'pricingInfo', 'termsAndConditions', 'eSignature'],
    sendAlertEmail: false,
    completionPath: 'extended',
    pricing: { variant: 'ensora' }, // overridden in getAgentConfig if surcharge
    termsUrl: TERMS_URL_ENSORA,
    termsLabel: TERMS_LABEL_ENSORA,
    business: {
      mccFilter: 'fixed',
      mccDefault: '8099',
      merchantFields: ['dateEstablished', 'ownershipType', 'industry', 'businessHours'],
      defaults: {
        merchandise: 'Medical Services',
        returnPolicy: 'NoReturn',
        settlementPolicy: 'OrderDate',
        merchandiseFullfillment: 'Merchant',
        merchandiseDeliverySpan: '1',
        businessLocation: 'Office',
      },
    },
    volume: {
      ...VOLUME_BASE,
      forceAllCardTypes: true,
      nachaDefaults: { ...ZERO_NACHA, ppd: '30', web: '40', ccd: '30' },
    },
  },
};

export function getAgentConfig(agentId) {
  if (isIntelecom(agentId)) return AGENT_CONFIGS.intelecom;
  if (isMW13601(agentId)) return { ...AGENT_CONFIGS.mwRevio, mwVariant: '13601', pricing: { variant: 'mw13601' } };
  if (isMW13602(agentId)) return { ...AGENT_CONFIGS.mwRevio, mwVariant: '13602', pricing: { variant: 'mw13602' } };
  if (isMemberworks(agentId)) return AGENT_CONFIGS[isMwGeneral(agentId) ? 'mwGeneral' : 'mwRevio'];
  if (isEnsoraSurcharge(agentId)) return { ...AGENT_CONFIGS.ensora, pricing: { variant: 'ensoraSurcharge' } };
  // Ensora Flat only (surcharge handled above): credit-only — ACH batch removed.
  if (isEnsora(agentId)) return { ...AGENT_CONFIGS.ensora, volume: { ...AGENT_CONFIGS.ensora.volume, creditOnly: true } };
  if (isTracerFlex(agentId)) return AGENT_CONFIGS.tracerflex;
  if (isPromotix(agentId)) return AGENT_CONFIGS.promotix;
  if (isExcelR8(agentId)) return AGENT_CONFIGS.excelR8;
  if (isEdining(agentId)) return AGENT_CONFIGS.edining;
  if (getAgentType(agentId) === 'revio') return AGENT_CONFIGS.revio;
  return AGENT_CONFIGS.trx;
}
